"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectAddress = SelectAddress;
exports.SelectButton = SelectButton;
exports.SelectMonth = SelectMonth;
exports.SelectYear = SelectYear;
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _reactSelect = _interopRequireWildcard(require("react-select"));
var _async = _interopRequireDefault(require("react-select/async"));
var _reactHighlightWords = _interopRequireDefault(require("react-highlight-words"));
var _connect = require("../connect");
var _Input = require("./Input");
var _utils = require("../utils");
var _Icon = _interopRequireDefault(require("../Icon"));
var _Dropdown = _interopRequireDefault(require("../Dropdown"));
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// ----- COMPONENT

/*
 * @example
 * Options structure:
 *
 * - id : id | value | $self
 * - name : label | text | name | $self
 * - ?icon : string (IconName) | Component
 *
 * [
 *   // แบบเดี่ยว
 *   { id: number, name: string, ?icon: IconName },
 *
 *   // แบบจัดกลุ่ม
 *   { name: string, options: [
 *      { ..item option.. }
 *   ]}
 * ]
 */

var Input = function Input(props) {
  return /*#__PURE__*/React.createElement(_reactSelect.components.Input, _extends({}, props, {
    isHidden: false
  }));
};
var Select = /*#__PURE__*/function (_Component) {
  _inherits(Select, _Component);
  var _super = _createSuper(Select);
  function Select(props) {
    var _this;
    _classCallCheck(this, Select);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onClickValue", function (e) {
      if (e.target) {
        var _this$inputRef, _this$inputRef$curren;
        if (e.target.classList.contains('s__multi-value__label')) {
          _this.selectText(e.target);
        } else if ((_this$inputRef = _this.inputRef) !== null && _this$inputRef !== void 0 && (_this$inputRef$curren = _this$inputRef.current) !== null && _this$inputRef$curren !== void 0 && _this$inputRef$curren.controlRef) {
          var _this$inputRef2, _this$inputRef2$curre;
          var dom = (_this$inputRef2 = _this.inputRef) === null || _this$inputRef2 === void 0 ? void 0 : (_this$inputRef2$curre = _this$inputRef2.current) === null || _this$inputRef2$curre === void 0 ? void 0 : _this$inputRef2$curre.controlRef.querySelector('.s__single-value');
          if (dom) _this.selectText(dom);
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "_expodeOptions", function (options) {
      if (options.some(function (o) {
        return o.options && o.options.length > 0;
      })) {
        return options.reduce(function (s, a) {
          if (a.options) {
            return s.concat(a.options);
          } else {
            s.push(a);
            return s;
          }
        }, []);
      }
      return options;
    });
    _defineProperty(_assertThisInitialized(_this), "onChange", function (d, action) {
      var options = _this.state.options;
      var isMultiple = !!_this.props.multiple;
      if (!!d) {
        if (_this.props.onChange) {
          if (isMultiple) {
            var outputs = d.map(function (o) {
              return o.orgData || options.find(function (p) {
                return (0, _utils.testValue)(p) === (0, _utils.testValue)(o);
              }) || o;
            });
            if (!!_this.props.url || !!options) {
              _this.props.onChange(outputs.map(function (o) {
                return (0, _utils.testValue)(o);
              }), outputs, action);
            } else {
              console.log('this.props.onChange else');
            }
          } else {
            var o = d.orgData || d;
            if (!!o) {
              _this.props.onChange((0, _utils.testValue)(o), o, action);
            } else {
              _this.props.onChange(null, null, action);
            }
          }
        }
      } else if (action.action === 'clear' || action.action === 'remove-value') {
        _this.props.onChange(null, null, action);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "loadOption", function (search, callback) {
      if (_this.searchDelay) clearTimeout(_this.searchDelay);
      _this.searchDelay = setTimeout(function () {
        if (_this.props.url) {
          (0, _connect.get)(_this.props.url, {
            search: search
          }).then(function (d) {
            var name = _this.props.set || 'datas';
            var options = d && d[name] || [];
            _this.setState({
              optionsLoaded: true,
              isLoading: false,
              options: options
            }, function () {
              if (callback) callback(options.map(_this.fetchOption));
            });
          });
        }
      }, 500);
    });
    _defineProperty(_assertThisInitialized(_this), "fetchOption", function (o) {
      if (o.options) return {
        label: (0, _utils.testLabel)(o),
        options: o.options.map(function (p) {
          return _this.fetchLabel(p, (0, _utils.option)(p, _this.props.renderText));
        })
      };
      return _this.fetchLabel(o, (0, _utils.option)(o, _this.props.renderText));
    });
    _this.state = {
      isLoading: false,
      isValued: false,
      optionsLoaded: false,
      options: []
    };
    _this.inputRef = /*#__PURE__*/React.createRef();
    return _this;
  }
  _createClass(Select, [{
    key: "selectText",
    value: function selectText(dom) {
      if (window.getSelection && document) {
        var _window$getSelection, _window$getSelection2;
        var range = document.createRange();
        range.selectNode(dom);
        (_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.removeAllRanges();
        (_window$getSelection2 = window.getSelection()) === null || _window$getSelection2 === void 0 ? void 0 : _window$getSelection2.addRange(range);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$inputRef3, _this$inputRef3$curre;
      if (this.props.focusSelecter && (_this$inputRef3 = this.inputRef) !== null && _this$inputRef3 !== void 0 && (_this$inputRef3$curre = _this$inputRef3.current) !== null && _this$inputRef3$curre !== void 0 && _this$inputRef3$curre.controlRef) this.inputRef.current.controlRef.addEventListener('click', this.onClickValue);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$inputRef4, _this$inputRef4$curre;
      if (this.props.focusSelecter && (_this$inputRef4 = this.inputRef) !== null && _this$inputRef4 !== void 0 && (_this$inputRef4$curre = _this$inputRef4.current) !== null && _this$inputRef4$curre !== void 0 && _this$inputRef4$curre.controlRef) this.inputRef.current.controlRef.removeEventListener('click', this.onClickValue);
    }
  }, {
    key: "formatOptionLabel",
    value: function formatOptionLabel(_ref, _ref2) {
      var label = _ref.label;
      var inputValue = _ref2.inputValue;
      return /*#__PURE__*/React.createElement(_reactHighlightWords.default, {
        highlightClassName: "red b",
        searchWords: inputValue.split(' '),
        textToHighlight: label
      });
    }
  }, {
    key: "fetchLabel",
    value: function fetchLabel(d, o) {
      o.orgData = d;
      o.orgLabel = o.labelText || o.label;
      if (!(0, _utils.isEmpty)(d.icon) && typeof d.icon === 'string') o.label = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Icon.default, {
        name: d.icon,
        fixWidth: true
      }), " ", o.label);
      return o;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      if (!document) return null;
      var _this$props = this.props,
        value = _this$props.value,
        multiple = _this$props.multiple,
        placeholder = _this$props.placeholder;
      var isAsync = !!this.props.url;
      var selectPorps = {
        ref: this.inputRef,
        placeholder: placeholder || '',
        menuPortalTarget: document.body,
        menuPlacement: 'auto',
        className: 'un-input-select-control',
        classNamePrefix: 's',
        styles: {
          menuPortal: function menuPortal(provided) {
            return _objectSpread(_objectSpread({}, provided), {}, {
              zIndex: 50
            });
          }
        },
        components: {
          Input: Input
        },
        filterOption: function filterOption(option, search) {
          if (isAsync || search.length <= 0 || option.data.orgLabel === undefined) return true;
          return new RegExp(search.replaceAll('*', '\\*').replaceAll('?', '\\?').replaceAll('[', '\\[').replaceAll(']', '\\]').replaceAll('(', '\\(').replaceAll(')', '\\)').replaceAll('+', '\\+').split(' ').join('|'), 'i').test(option.data.orgLabel);
        },
        onChange: this.onChange,
        onInputChange: function onInputChange(v) {
          return _this2.setState({
            isValued: !(0, _utils.isEmpty)(v)
          });
        }
      };
      if (!this.props.noClear) {
        selectPorps.isClearable = true;
      }
      if (isAsync) {
        selectPorps.cacheOptions = !this.props.noCache;
        selectPorps.defaultOptions = this.state.options.map(this.fetchOption);
        selectPorps.onFocus = function () {
          //s__single-value
          if (!_this2.state.optionsLoaded || !!_this2.props.noCache) {
            _this2.setState({
              isLoading: true
            });
            _this2.loadOption();
          }
        };
        selectPorps.isLoading = this.state.isLoading;
        selectPorps.loadOptions = this.loadOption;
      } else if (!!this.props.options && Array.isArray(this.props.options)) {
        selectPorps.options = this.props.options.map(this.fetchOption);
      }
      if (multiple) {
        selectPorps.isMulti = true;
        selectPorps.closeMenuOnSelect = false;
      }
      if (this.props.highlight) {
        selectPorps.formatOptionLabel = this.formatOptionLabel;
      }
      selectPorps.value = '';
      //selectPorps.defaultMenuIsOpen = true

      if (!(0, _utils.isEmptyValue)(value)) {
        if (Array.isArray(value)) {
          //console.log(this.props.label + ' value isArray', value)
          selectPorps.value = value.map(function (o) {
            return (0, _utils.option)(o, _this2.props.renderText);
          });
        } else if (_typeof(value) === 'object') {
          //console.log(this.props.label + ' value isObject', value)
          selectPorps.value = (0, _utils.option)(value, this.props.renderText);
        } else if (selectPorps.options && Array.isArray(selectPorps.options) || selectPorps.defaultOptions && Array.isArray(selectPorps.defaultOptions)) {
          //console.log(this.props.label + ' selectPorps.options', value)
          var options = selectPorps.options || selectPorps.defaultOptions;
          var fv = this._expodeOptions(options).find(function (o) {
            return o.value === value;
          });
          if (fv) selectPorps.value = fv;
        } else {
          console.log(this.props.label + ' value else', value, selectPorps);
        }
      }
      var input = /*#__PURE__*/React.createElement("div", {
        className: (0, _utils.clsNames)((0, _Input.createInputboxClass)('un-input-select', this.props), (!(0, _utils.isEmptyValue)(selectPorps.value) || this.state.isValued) && '-focus')
      }, /*#__PURE__*/React.createElement("div", {
        className: 'un-inputbox-control'
      }, !this.props.form && !!this.props.label && (0, _Input.createInputboxLabel)(this.props.label), isAsync ? /*#__PURE__*/React.createElement(_async.default, selectPorps) : /*#__PURE__*/React.createElement(_reactSelect.default, selectPorps)));
      if (this.props.form) return (0, _Input.createFormitem)(input, this.props);
      if (typeof this.props.classBox === 'string') return /*#__PURE__*/React.createElement("div", {
        className: this.props.classBox
      }, input);
      return input;
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props) {
      if (!!props.options) {
        return {
          options: props.options
        };
      }
      return null;
    }
  }]);
  return Select;
}(React.Component);
exports.default = Select;
function SelectAddress(props) {
  var value = (0, React.useMemo)(function () {
    var texts = [];
    if (props.value) {
      var _props$value$province;
      var isBkk = (_props$value$province = props.value.province) === null || _props$value$province === void 0 ? void 0 : _props$value$province.includes('กรุงเทพ');
      if (props.value.subdistrict) texts.push((isBkk ? 'แขวง' : 'ตำบล') + props.value.subdistrict);
      if (props.value.district) texts.push((isBkk ? 'เขต' : 'อำเภอ') + props.value.district);
      if (props.value.province) texts.push((isBkk ? '' : 'จังหวัด') + props.value.province);
      if (props.value.zipcode) texts.push(props.value.zipcode);
    }
    return texts.length > 0 ? {
      id: 0,
      name: texts.join(' ')
    } : '';
  }, [props.value]);
  var inputProp = _objectSpread(_objectSpread({}, props), {}, {
    url: 'https://service.un-no.net/map/address',
    highlight: true,
    value: value
  });
  return /*#__PURE__*/React.createElement(Select, _extends({}, inputProp, {
    onChange: function onChange(_, _ref3) {
      var subdistrict = _ref3.subdistrict,
        district = _ref3.district,
        province = _ref3.province,
        zipcode = _ref3.zipcode;
      return props.onChange({
        subdistrict: subdistrict,
        district: district,
        province: province,
        zipcode: zipcode
      });
    }
  }));
}
function SelectMonth(props) {
  var propsEL = {
    label: props.label,
    value: props.value,
    onChange: props.onChange,
    classBox: props.classBox,
    noClear: props.noClear
  };
  var lc = (0, _utils.dateLocale)();
  var months = [];
  for (var i = 0; i < 12; i++) {
    months.push({
      value: i + 1,
      text: lc && lc.localize ? lc.localize.month(i) : ''
    });
  }
  propsEL.options = months;
  if (props.fixWidth) propsEL.className = (0, _utils.clsNames)('-fix-width w-input-month', !!props.onChange && !props.noClear && '-clear');
  if (props.className) propsEL.className += ' ' + props.className;
  return /*#__PURE__*/React.createElement(Select, propsEL);
}
function SelectYear(props) {
  var propsEL = {
    label: props.label,
    value: props.value,
    onChange: props.onChange,
    classBox: props.classBox,
    noClear: props.noClear
  };
  var min = props.min || 2000;
  var max = props.max || new Date().getFullYear() + 5;
  var be = _utils.locale === 'th';
  propsEL.options = [];
  for (var x = max; x >= min; x--) propsEL.options.push({
    value: x,
    text: x + (be ? 543 : 0)
  });
  if (props.fixWidth) propsEL.className = (0, _utils.clsNames)('-fix-width w-input-year', !!props.onChange && !props.noClear && '-clear');
  if (props.className) propsEL.className += ' ' + props.className;
  return /*#__PURE__*/React.createElement(Select, propsEL);
}

// TODO SelectButton
function SelectButton(props) {
  var current = 'x';
  return /*#__PURE__*/React.createElement(_Dropdown.default, {
    button: /*#__PURE__*/React.createElement(_Button.default, null, current)
  });
}